import MainLayout from "../layout/main-layout";
import RORSection from "../Components/ROR/ror-section";
import RORBenefits from "../Components/ROR/ror-benefits";
import RORProcess from "../Components/ROR/ror-process";
import WhyChooseROR from "../Components/ROR/why-choose-ror";
import RORContactSection from "../Components/ROR/ror-contact-section";
import MetaTags from "../utils/meta-tags";
import { useRef } from "react";

function RubyOnRails() {
  const contactRef = useRef<HTMLDivElement>(null);

  const handleScrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <MetaTags
        title="Ruby on Rails Development Company | SoftCoding Solutions"
        description="Get scalable and secure web applications built by expert Ruby on Rails developers. End-to-end Rails development services tailored to your business goals."
        canonical="https://softcodingsolutions.com/ruby-on-rails-development-company"
        og={{
          title: "Ruby on Rails Development Company | SoftCoding Solutions",
          description:
            "Hire expert Ruby on Rails developers to build secure, scalable, and fast web applications tailored to your business needs.",
          url: "https://softcodingsolutions.com/ruby-on-rails-development-company",
          type: "website",
          site_name: "SoftCoding Solutions",
          image:
            "https://softcodingsolutions.com/static/media/logo%20company.23b84ead7179e68dfe2f.png",
          imageWidth: "1200",
          imageHeight: "630",
        }}
      />
      <MainLayout>
        <RORSection onScroll={handleScrollToContact} />
        <RORBenefits />
        <RORProcess />
        <WhyChooseROR />
        <RORContactSection contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default RubyOnRails;
